import { utils, LitElement, html, css, unsafeHTML, paths, t } from '@hh/global.js'
const { one, reRenderShopifySections, addToCart, updateCartItem } = utils;

class HHBundle extends LitElement {
  static properties = {
    _data: {
      state: true,
    },
    _bundle: {
      state: true,
    },
    loading: {
      state: true,
    },
    _currentStep: {
      state: true,
    },
    _products: {
      state: true,
    },
    _previewProduct: {
      state: true,
    },
    _lineItemId: {
      state: true,
    },
    _savedBundlesCount: {
      state: true,
    },
  }

  constructor() {
    super();
    this._previewProduct = null;
    this.loading = false;
    document.addEventListener('customer:login', () => {
      // close login modal, save bundle
      document.getElementById('login-dialog').querySelector('.main-bundle__backdrop').click();
      this.saveBundle();
    });
  }

  firstUpdated() {
    const params = new URLSearchParams(window.location.search);
    const data = JSON.parse(one('script', this).textContent);
    this._bundle = data.steps.map((step) => ([]));
    this._currentStep = +params.get('s') || 0;
    this._savedBundlesCount = data.savedBundles?.length || 0;

    if (this._currentStep >= data.steps.length) {
      this._currentStep = 0;
    }

    const bundleData = params.get('b');
    if (bundleData) {
      const bundle = data.steps.map((step) => ([]));
      bundleData.split('|').map((step) => {
        return step.split(',').map((item,) => {
          const [variantId, qty] = item.split(':');
          if (!variantId) {
            return null;
          }
          return {
            variantId: parseInt(variantId, 10),
            qty: parseInt(qty, 10),
          };
        }).filter((item) => item);
      }).forEach((step, index) => {
        step.forEach((item) => {
          if (
            data.steps[index]
            && data.steps[index].products.find((product) => product.variantId === item.variantId)
          ) {
            bundle[index].push(item);
          }
        });
      });
      this._bundle = [...bundle];
    }
    this._data = data;
    if (params.get('id')) {
      this._lineItemId = params.get('id');
    }
    if (params.get('save')) {
      this.saveBundle();
    }
  }

  updateBundle(event) {
    if (event.detail.qty < 1) {
      const bundle = [...this._bundle];
      bundle[this._currentStep] = this._bundle[this._currentStep].filter((item) => item.variantId !== event.detail.variantId);
      this._bundle = [...bundle];
    } else {
      const addedItemIndex = this._bundle[this._currentStep].findIndex((item) => item.variantId === event.detail.variantId);
      const addedItem = this._bundle[this._currentStep][addedItemIndex];
      const bundle = [...this._bundle];
      let qty = event.detail.qty;
      const currentQty = bundle[this._currentStep].reduce(
        (acc, item) => {
          if (item.variantId !== event.detail.variantId) {
            acc += item.qty;
          }
          return acc;
        }, 0
      );
      const maxQty = this._data.steps[this._currentStep].quantity - currentQty;

      if (qty > maxQty) {
        qty = maxQty;
      }

      if (qty < 1) {
        return;
      }

      if (addedItem) {
        bundle[this._currentStep][addedItemIndex] = {
          variantId: event.detail.variantId,
          qty,
        };
      } else{
        bundle[this._currentStep].push({
          variantId: event.detail.variantId,
          qty
        });
      }
      this._bundle = [...bundle];
    }

    this.updateLocation();
  }

  formatParams() {
    return this._bundle.map((items, index) => {
      return items.map((item) => `${item.variantId}:${item.qty}`).join(',');
    }).join('|');
  }

  updateLocation() {
    window.history.replaceState(
      null,
      '',
      `${window.location.pathname}?b=${this.formatParams()}&s=${this._currentStep}${this._lineItemId ? `&id=${this._lineItemId}` : ''}`
    );
  }

  openLoginModal(e) {
    e?.preventDefault();
    e?.stopPropagation();
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'return_to';
    input.value = `${window.location.pathname}?b=${this.formatParams()}&s=${this._currentStep}&save=1`;
    document.getElementById('customer_login')?.appendChild(input);
    this.dispatchEvent(
      new CustomEvent('openModal', {
        bubbles: true,
        composed: true,
        detail: {
          id: 'login-dialog'
        },
      })
    )
  }

  openShareModal(e) {
    e.preventDefault();
    e.stopPropagation();
    document.dispatchEvent(new CustomEvent('updateShareUrl'));
    this.dispatchEvent(
      new CustomEvent('openModal', {
        bubbles: true,
        composed: true,
        detail: {
          id: 'share-dialog'
        },
      })
    )
  }

  saveBundle() {
    this.loading = true;

    return fetch('/?view=account').then((response) => response.json()).then((data) => {
      if (data.id) {
        const url = `${window.location.pathname}?b=${this.formatParams()}&s=${this._currentStep}`;
        this._data.customerId = data.id;
        const bundles = data.saved_bundles || [];
        const savedBundleIndex = bundles.findIndex((bundle) => bundle.handle === this._data.product_handle);
        const payload = {
          finished: this._completedSteps.filter(i => i).length,
          total: this._data.steps.length,
          handle: this._data.product_handle,
          url,
        }
        if (savedBundleIndex >= 0)  {
          bundles[savedBundleIndex] = payload
        } else if (bundles.length < 10) {
          bundles.push(payload);
        } else {
          return;
        }
        this._savedBundlesCount = bundles.length;
        window.history.replaceState(
          null,
          '',
          url
        );
        return fetch("https://stg-us.myshopify.com/apps/tools/api/account", {
          "headers": {
            "content-type": "application/x-www-form-urlencoded",
          },
          "body": new URLSearchParams({
            'customer[id]': data.id,
            'metafields[hhschleich.saved_bundles.json]': JSON.stringify(bundles)
          }).toString(),
          "method": "POST",
        });
      } else {
        this.openLoginModal()
      }
    }).finally(() => {
      this.loading = false;
    });
  }

  onSaveBundle(event) {
    if (this._data.customerId) {
      this.saveBundle();
    } else {
      this.openLoginModal(event);
    }
  }

  changeStep(step) {
    if (step >= this._data.steps.length) {
      this.addBundleToCart();
      return;
    }
    this._currentStep = step;
    this.updateLocation();
  }

  async addBundleToCart() {
    this.loading = true;
    const items = this._bundle.reduce((acc, step, index) => {
      const products = [];
      step.forEach((item) => {
        const product = this._data.steps[index].products.find((product) => product.variantId === item.variantId);
        if (product) {
          products.push({
            id: item.variantId,
            qty: item.qty,
            uid: product.uid,
            pr: product.priceCents,
          });
        }
      });
      return [...acc, ...products];
    }, []);
    const properties = {
      _bundle: JSON.stringify(items),
      _query: this.formatParams(),
      _uid: this._data.uid,
      _bundleValue: this._data.value,
      _bundleType: this._data.type,
    };
    const data = {
      items: [
        {
          id: this._data.variant_id,
          qty: 1,
          properties
        }
      ]
    };
    if (this._lineItemId) {
      await reRenderShopifySections(
        await updateCartItem({
        id: this._lineItemId,
        properties,
      }));
      this._lineItemId = null;
    } else {
      await reRenderShopifySections(await addToCart(data));
    }

    this.loading = false;
    this._bundle = this._data.steps.map((step) => ([]));
    this._currentStep = 0;

    // remove saved bundle
    fetch('/?view=account').then((response) => response.json()).then((data) => {
      const bundles = data.saved_bundles || [];
      const savedBundleIndex = bundles.findIndex((bundle) => bundle.handle === this._data.product_handle);
      if (savedBundleIndex >= 0) {
        bundles.splice(savedBundleIndex, 1);
        this._savedBundlesCount = bundles.length;
        return fetch("https://stg-us.myshopify.com/apps/tools/api/account", {
          "headers": {
            "content-type": "application/x-www-form-urlencoded",
          },
          "body": new URLSearchParams({
            'customer[id]': data.id,
            'metafields[hhschleich.saved_bundles.json]': JSON.stringify(bundles)
          }).toString(),
          "method": "POST",
        });
      }
    });

    this.updateLocation();
    this.dispatchEvent(
      new CustomEvent('productAdded', {
        bubbles: true,
        composed: true,
        detail: {
          id: 'cart-notification',
          product_title: this._data.product_title,
          auto_close: 2500,
        },
      })
    )
    window.dispatchEvent(
      new CustomEvent('cart-message:added', {
        bubbles: true,
        composed: true,
        detail: {
          title: this._data.product_title,
          link: `/products/${this._data.product_handle}`,
        },
      })
    );
  }

  get _completedSteps() {
    return this._bundle.map((items, index) => {
      return items.reduce((acc, item) => acc + item.qty, 0) >= this._data.steps[index].quantity;
    });
  }

  get isCurrentStepFinished() {
    return this._completedSteps[this._currentStep];
  }

  get isBundleFinished() {
    return this._completedSteps.every(i => i);
  }

  get currentItemsCount() {
    return this._bundle[this._currentStep].reduce((acc, item) => acc + item.qty, 0);
  }

  render() {
    if (!this._data) return html`<div></div>`;
    const currentStep = this._data.steps[this._currentStep];
    const title = t('sections.main-bundle.title').replace('{{ step }}', this._currentStep + 1).replace('{{ count }}', currentStep.quantity).replace('{{ title }}', currentStep.title);
    return html`
    <div class="bundle">
      <hh-bundle-summary
        .currentStep="${this._currentStep}"
        .steps="${this._data.steps}"
        .bundle="${this._bundle}"
        .message="${this._data.discount_message}"
        .currentItemsCount="${this.currentItemsCount}"
        .packagingIncluded="${this._data.packaging_included}"
        .boxImage="${this._data.box_image}"
        @changeStep="${(e) => this.changeStep(e.detail.step)}"
        class="bundle__summary"
      >
        <hh-bundle-buttons
          direction="column"
          .currentStep="${this._currentStep}"
          .isCurrentStepFinished="${this.isCurrentStepFinished}"
          .isBundleFinished="${this.isBundleFinished}"
          .stepsCount="${this._data.steps.length}"
          .isLoading="${this.loading}"
          @onPrevStep="${() => this.changeStep(this._currentStep - 1)}"
          @onNextStep="${() => this.changeStep(this._currentStep + 1)}"
        ></hh-bundle-buttons>
      </hh-bundle-summary>
      <div>
        ${this._previewProduct ? html`<hh-bundle-modal
          .product="${this._previewProduct}"
          .bundle="${this._bundle}"
          .currentStep="${this._currentStep}"
          .maxStepQty="${currentStep.quantity}"
          @close="${() => this._previewProduct = null}"
          @updateBundle="${this.updateBundle}"
        ></hh-bundle-modal>` : ''}
        <div class="bundle__title">
          <div class="bundle__title-text">
            ${t('sections.main-bundle.step_of').replace('{{ number }}', this._currentStep + 1).replace('{{ total }}', this._data.steps.length)}:
            ${title}
          </div>
          <div class="bundle__progress">
            <div class="bundle__progress-bar">
              <div class="bundle__progress-bg" style="width: ${this.currentItemsCount/currentStep.quantity * 100}%"></div>
            </div>
            <div class="bundle__progress-text">
              ${this.currentItemsCount}/${currentStep.quantity} ${t('sections.main-bundle.selected')}
            </div>
          </div>
        </div>
        ${currentStep.description ? html`<div class="bundle-step__description">${currentStep.description}</div>` : ''}
        <div class="bundle__save">
          <hh-button-wrapper theme='secondary'>
            <button class="bundle__save-button ${this.loading ? 'loading' : ''}" @click="${this.onSaveBundle}">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18" height="18" width="18">
                <g id="Outline">
                  <path stroke-linejoin="round" stroke-linecap="round" stroke-width="1.2" stroke="#646464" d="M12.1117 1.00012H1.8896C1.64358 1.01166 1.41209 1.11998 1.24558 1.30147C1.07908 1.48295 0.991065 1.7229 1.00072 1.969V16.0311C0.991065 16.2772 1.07908 16.5171 1.24558 16.6986C1.41209 16.8801 1.64358 16.9884 1.8896 17H16.1117C16.3577 16.9884 16.5892 16.8801 16.7557 16.6986C16.9222 16.5171 17.0102 16.2772 17.0006 16.0311V5.84897L12.1117 1.00012Z" id="Vector"></path>
                  <path stroke-linejoin="round" stroke-linecap="round" stroke-width="1.2" stroke="#646464" d="M9.88829 1.00012H3.22168V5.00009H9.88829V1.00012Z" id="Vector_2"></path>
                  <path stroke-linejoin="round" stroke-linecap="round" stroke-width="1.2" stroke="#646464" d="M13.8883 8.55566H3.22168V17H13.8883V8.55566Z" id="Vector_3"></path>
                </g>
              </svg>  
              ${t('sections.main-bundle.save_for_later')}
              ${this._data.customerId ?  html`(${this._savedBundlesCount}/10)` : ''}
            </button>
          </hh-button-wrapper>

          <hh-button-wrapper theme='secondary'>
            <button class="bundle__save-button" @click="${this.openShareModal}">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                <g transform="translate(1.43,1) scale(1.55) translate(-1.625,-1.0761)">
                  <path d="M1.625 8.125V10.2917C1.625 10.579 1.73914 10.8545 1.9423 11.0577C2.14547 11.2609 2.42102 11.375 2.70833 11.375H10.2917C10.579 11.375 10.8545 11.2609 11.0577 11.0577C11.2609 10.8545 11.375 10.579 11.375 10.2917V8.125" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.14775 1.27137C6.34301 1.0761 6.65959 1.0761 6.85485 1.27137L9.56319 3.9797C9.75845 4.17496 9.75845 4.49154 9.56319 4.6868C9.36793 4.88207 9.05135 4.88207 8.85609 4.6868L6.5013 2.33203L4.14652 4.6868C3.95126 4.88207 3.63468 4.88207 3.43942 4.6868C3.24415 4.49154 3.24415 4.17496 3.43942 3.9797L6.14775 1.27137Z" fill="currentColor"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 1.125C6.77614 1.125 7 1.34886 7 1.625V8.125C7 8.40114 6.77614 8.625 6.5 8.625C6.22386 8.625 6 8.40114 6 8.125V1.625C6 1.34886 6.22386 1.125 6.5 1.125Z" fill="currentColor"/>
                </g>
              </svg>
              ${t('sections.main-bundle.share')}
            </button>
           </hh-button-wrapper>
        </div>
        <hh-bundle-step
          @updateBundle="${this.updateBundle}"
          @previewProduct="${(e) => this._previewProduct = {...e.detail.product}}"
          .step="${currentStep}"
          .bundle="${this._bundle}"
          .currentStep="${this._currentStep}"
          .isFinished="${this.isCurrentStepFinished}"
          .type="${this._data.type}"
        >
        </hh-bundle-step>
        <hh-bundle-buttons
          class="bundle__buttons"
          direction="row"
          .currentStep="${this._currentStep}"
          .isCurrentStepFinished="${this.isCurrentStepFinished}"
          .isBundleFinished="${this.isBundleFinished}"
          .stepsCount="${this._data.steps.length}"
          .isLoading="${this.loading}"
          @onPrevStep="${() => this.changeStep(this._currentStep - 1)}"
          @onNextStep="${() => this.changeStep(this._currentStep + 1)}"
        ></hh-bundle-buttons>
      </div>
    </div>
    `
  }

  static styles = css`
    hh-button-wrapper {
      --hh-background: var(--hh-color-brand-secondary);
      --hh-background-hover: transparent;
      --hh-color-disabled: var(--hh-color-light);
      --hh-background-disabled: var(--hh-color-subdued);
      --hh-font: var(--hh-button-font);
      --hh-letter-spacing: var(--hh-button-letter-spacing);
      --hh-padding: var(--hh-spacing-xs) 0;
      --hh-height: auto;
      --hh-max-height: auto;
      --hh-max-width: 22rem;
      --hh-transition: all var(--hh-duration-default) ease;
      --hh-border-bottom-offset: -1px;
      --hh-border-radius: 9999px;
    }

    hh-button-wrapper[theme='secondary'] {
      --hh-color: var(--hh-color-brand-secondary);
      --hh-background: transparent;
      --hh-color-hover: var(--hh-color-day);
      --hh-color-disabled: var(--hh-color-subdued);
      --hh-background-disabled: transparent;
      --hh-border-disabled: var(--hh-color-subdued);
    }

    .bundle {
      padding-top: var(--hh-spacing-xl);
      position: relative;
    }

    .bundle__title {
      font: var(--hh-h2-font);
      letter-spacing: var(--hh-h2-letter-spacing);
      margin-bottom: var(--hh-spacing-sm);
      color: var(--hh-color-night);
    }

    .bundle__buttons {
      display: none;
    }

    .bundle__progress {
      display: none;
    }

    .bundle__progress-bar {
      width: 100%;
      height: var(--hh-spacing-sm);
      border-radius: 6.6rem;
      border: 0.1rem solid rgba(var(--hh-color-night-rgb), 0.22);
      overflow: hidden;
    }

    .bundle__progress-bg {
      height: 100%;
      background: var(--hh-color-orange);
    }

    .bundle-step__description {
      font: var(--hh-body-sm-font);
      margin-bottom: var(--hh-spacing-xl);
    }

    .bundle__save {
      display: flex;
      gap: var(--hh-spacing-2xl);
      margin-bottom: var(--hh-spacing-xl);
    }

    .bundle__save-button:hover:not(:disabled) {
      background-color: var(--hh-background-hover, var(--hh-color-background));
      color: var(--hh-color-text);
    }

    .bundle__save-button svg {
      position: relative;
      top: 2px;
      right: 2px;
    }

    @media (min-width: 1024px) {
      .bundle {
        display: flex;
        flex-direction: row-reverse;
        gap: var(--hh-spacing-3xl);
        align-items: flex-start;
      }
      .bundle hh-bundle-summary {
        position: sticky;
        top: 0;
      }
      .bundle > * {
        flex: 1;
      }
      .bundle__summary {
        max-width: 43rem;
      }
      .bundle__buttons{
        margin-top: var(--hh-spacing-xl);
        padding: var(--hh-spacing-xl) 0;
        display: flex;
        justify-content: center;
      }
      .bundle__title{
        padding-top: var(--hh-spacing-xl);
        margin-bottom: var(--hh-spacing-xl);
        display: flex;
        gap: var(--hh-spacing-sm);
        align-items: flex-end;
      }
      .bundle__title-text{
        flex: 1;
      }
      .bundle__progress{
        display: flex;
        gap: var(--hh-spacing-xs);
        align-items: center;
      }
      .bundle__progress-bar{
        width: 8rem;
      }
      .bundle__progress-text {
        font: var(--hh-body-bold-lg-font);
      }
    }
  `
}

customElements.define('hh-bundle', HHBundle)
